import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants';
import { TwitchIcon, GoogleIcon } from '../common/icons';

/**
 * AuthMethodSelect — Initial auth step showing Twitch, Google, and Email options.
 *
 * @param {Object} props
 * @param {function} props.onSelectTwitch - Called when Twitch button is clicked
 * @param {function} props.onSelectGoogle - Called when Google button is clicked
 * @param {function} props.onSelectEmail - Called when Email button is clicked
 * @returns {JSX.Element}
 */
function AuthMethodSelect({ onSelectTwitch, onSelectGoogle, onSelectEmail }) {
  return (
    <div className="auth-step auth-method-select">
      <h2 className="auth-step__title">Sign Up to Get Started</h2>
      <p className="auth-step__subtitle">Choose how you'd like to continue</p>

      <div className="auth-method-select__buttons">
        <button
          type="button"
          className="auth-method-btn auth-method-btn--twitch"
          onClick={onSelectTwitch}
        >
          <TwitchIcon size={22} color="currentColor" />
          <span>Continue with Twitch</span>
        </button>

        <button
          type="button"
          className="auth-method-btn auth-method-btn--google"
          onClick={onSelectGoogle}
        >
          <GoogleIcon size={22} />
          <span>Continue with Google</span>
        </button>

        <div className="auth-method-select__divider">
          <span className="auth-method-select__divider-line" />
          <span className="auth-method-select__divider-text">or</span>
          <span className="auth-method-select__divider-line" />
        </div>

        <button
          type="button"
          className="auth-method-btn auth-method-btn--email"
          onClick={onSelectEmail}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="M22 4L12 13L2 4" />
          </svg>
          <span>Continue with Email</span>
        </button>
      </div>

      <p className="auth-method-select__legal">
        By continuing, you agree to our{' '}
        <Link
          className="auth-method-select__legal-link"
          to={ROUTES.TERMS}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link
          className="auth-method-select__legal-link"
          to={ROUTES.PRIVACY}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        .
      </p>
    </div>
  );
}

AuthMethodSelect.propTypes = {
  onSelectTwitch: PropTypes.func.isRequired,
  onSelectGoogle: PropTypes.func.isRequired,
  onSelectEmail: PropTypes.func.isRequired,
};

export default AuthMethodSelect;
